/* eslint-disable */
/**
 * Vercel Blob URLs used by Profile modal redesign (`ProfileModalV2Layout.ts`).
 * Keep this list deduplicated and wire it via `VERCEL_BLOB_PRELOAD_PRIORITIZED`.
 */
const P = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Redesign/profile'

export const PROFILE_MODAL_BLOB_PRELOAD_URLS: readonly string[] = [
  `${P}/background.webp`,
  `${P}/img_account_info.webp`,
  `${P}/btn_close.webp`,
  `${P}/btn_logout.webp`,
  `${P}/btn_connect_wallet.webp`,
  `${P}/btn_save_changes.webp`,
  `${P}/btn_edit_nink_name.webp`,
  `${P}/btn_edit_email.webp`,
  `${P}/btn_copy_wallet_address.webp`,
  `${P}/panel_change_password.webp`,
  `${P}/btn_cancel.webp`,
  `${P}/btn_edit_avatar.webp`,
  `${P}/avatar_image.webp`,
  `${P}/avatar_mask.webp`,
  `${P}/main_act_frame.webp`,
  `${P}/levelmark.webp`,
  `${P}/btn_active_panel.webp`,
  `${P}/btn_inactive_panel.webp`,
  `${P}/ico_profile_panel.webp`,
  `${P}/ico_settings_panel.webp`,
  `${P}/ico_leaderboard_panel.webp`,
  `${P}/avtive_avatar_act_frame.webp`,
  `${P}/inactive_avatar_act_frame.webp`,
  `${P}/avatar_preview_act_frame.webp`,
  `${P}/btn_show_purchased_avatar.webp`,
  `${P}/btn_show_shop_avatar.webp`,
  `${P}/panel_settings.webp`,
  `${P}/ico_settings_lang.webp`,
  `${P}/combo_lang.webp`,
  `${P}/img_settings_music.webp`,
  `${P}/ico_music.webp`,
  `${P}/ico_sound.webp`,
  `${P}/img_click_sound.webp`,
  `${P}/img_leaderboard_profile.webp`,
  `${P}/img_leaderboard_table_header.webp`,
  `${P}/ranking_1.webp`,
  `${P}/ranking_2.webp`,
  `${P}/ranking_3.webp`,
  `${P}/ranking_other.webp`,
  `${P}/scrollbar_leaderboard.webp`,
  `${P}/btn_leaderboard_scrol.webp`,
  `${P}/btn_leaderboard.webp`,
  `${P}/search_leaderboard.webp`,
]
